import React from 'react'
import { Link } from 'react-router-dom'

const CmsMainContent = () => {
    const JavascriptVoid = (event) => {
        event.preventDefault();
    };
    return (
        <>
            <>
                <section>
                    <div className="container mt-5">
                        <div className="row">
                            <div className="col-lg-12 services-details">
                                <div className="ml-about-content">
                                    {/* <h2>Our CMS Website Design Services: </h2> */}
                                    <h1>Leading CMS Development Company</h1>
                                    <div className="bar" />
                                    <p>
                                        At Alobha Technologies, we offer four types of CMS Website design
                                        and development:
                                    </p>
                                    <p>
                                        Alobha Technologies, <b>Top CMS Development Company in India</b>, enable you to drive your online business in a way that is organized and deliberate. We will design a CMS Website that will satisfy the administration requirements of your business. In its simplest form, a Content Management System will give you the ability to either add or remove content from your website. A more advanced CMS solution will allow you to alter both the style and structural components of your website.
                                    </p>
                                </div>
                            
                                <ul className="text_color">
                                    <li>
                                        <b>Standard CMS:</b>
                                        Simple CMS application allows the administrator to add a block of
                                        content to the website through the use of a "What You See Is What
                                        You Get" interface.
                                    </li>
                                    <li>
                                        <b>Complex CMS:</b>
                                        The complex CMS contains all the functionalities of the simple CMS
                                        but with improved functionality, speeding up the user’s
                                        experience. This CMS offers an advanced preview and edit option,
                                        whereby you can alter and test your existing webpage in complete
                                        privacy.
                                    </li>
                                    <li>
                                        <b>Open Source CMS:</b>
                                        Open source or off-the-shelf CMS’s can reduce the need for costly
                                        site maintenance, empowering users to manage their own content.
                                    </li>
                                    <li>
                                        <b>Custom CMS:</b> Alobha designed and developed a custom CMS for
                                        the everyday user. Using proven technology backed by Microsoft, we
                                        have created an administration interface, giving users complete
                                        control over their website and administration process.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="services-details-area ptb-80">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 services-details-image">
                                <img loading="lazy"
                                    src="assets/img/service-detail-image/wordpress.webp"
                                    className="wow fadeInUp"
                                    alt=""
                                />
                            </div>
                            <div className="col-lg-6 services-details">
                                <div className="ml-about-content">
                                    {/* <h2>Wordpress Development Company, India</h2> */}
                                    <h2>Your Trusted WordPress Website Development Company</h2>
                                    <div className="bar" />
                                    <p>
                                        Alobha Technologies is one of the established <b>Wordpress Website development company in India</b> which offers complete custom WordPress website development and WordPress website design services to various clients all over the world. We are experts in crafting responsive WordPress themes.
                                    </p>
                                    <div className="services-details-accordion">
                                        {/* <ul className="accordion">
                                            <li className="accordion-item">
                                                <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                    Which material types can you work with?
                                                </Link>
                                            </li>
                                            <li className="accordion-item">
                                                <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                    Is Smart Lock required for instant apps?
                                                </Link>
                                            </li>
                                            <li className="accordion-item">
                                                <Link className="accordion-title" to="/" onClick={JavascriptVoid}>
                                                    Can I have multiple activities in a single feature?
                                                </Link>
                                            </li>
                                        </ul> */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 services-details">
                                <div className="services-details-desc">
                                    <h3>
                                        <b>WordPress Services we offer:</b>
                                    </h3>
                                    <ul className="text_color">
                                        <li>Web design and development</li>
                                        <li>Implementation and setup services</li>
                                        <li>Template design</li>
                                        <li>Customized plugin development</li>
                                        <li>WordPress theme development</li>
                                        <li>Responsive layout creation</li>
                                        <li>WordPress eCommerce</li>
                                        <li>Up gradation features</li>
                                        <li>Hosting services</li>
                                        <li>Mobile website creation</li>
                                        <li>Maintenance and support</li>
                                    </ul>
                                    <h3>
                                        <b>Why WordPress Rules the World of CMS?</b>
                                    </h3>
                                    <ul className="text_color">
                                        <li>User friendly</li>
                                        <li>Faster implementation</li>
                                        <li>Ease of maintenance</li>
                                        <li>Customized well and easy</li>
                                        <li>Affordable cost</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 services-details">
                                <div className="services-details-desc mb-2">
                                    {/* <h3>
                                        <b>WordPress Development Company</b>
                                    </h3> */}
                                    <h3><b>Best WordPress Website Development expert</b></h3>
                                    <p>
                                        Having years of experience and expertise in building WordPress
                                        plugin, themes and Ecommerce stores according to client's needs,
                                        we customize the look and feel with various theme and templates.
                                        We also create a customized template as per the need and implement
                                        it in WordPress.
                                    </p>
                                </div>
                                <div className="services-details-desc mb-2">
                                    <h3>
                                        <b>Responsive Layouts</b>
                                    </h3>
                                    <p>
                                        We Understand the importance of Attractive Responsive Layouts, So
                                        with Every Internet Enabled Device We Ensure That You Get A
                                        Website Which Is Compatible
                                    </p>
                                </div>
                                <div className="services-details-desc mb-2">
                                    <h3>
                                        <b>Customized Plug-Ins</b>
                                    </h3>
                                    <p>
                                        We Design Plug-Ins That Can Be Customized to Your Specific Needs,
                                        Providing Robustness in The Backend as Well.
                                    </p>
                                </div>
                                <div className="services-details-desc mb-2">
                                    <h3>
                                        <b>Complete Security</b>
                                    </h3>
                                    <p>
                                        Keeping in mind the popularity and sensitivity of WordPress, we
                                        use best security tools and follow best practices.
                                    </p>
                                </div>
                                <div className="services-details-desc mb-2">
                                    <h3>
                                        <b>Maintenance &amp; Support</b>
                                    </h3>
                                    <p>
                                        As Wordpress development company India, we offer our clients up to
                                        three months of free maintenance and support services to help them
                                        focus on their business while we take care of their technical
                                        needs.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="container mt-4">
                        <div className="row">
                            <div className="col-lg-6 services-details">
                                <div className="ml-about-content">
                                    <h2>Drupal Development Company, India </h2>
                                    <div className="bar" />
                                    <p>
                                        "Drupal is an open source{" "}
                                        <Link to="/about-us" className="inner-link">
                                            <b>content management System(CMS)</b>
                                        </Link>{" "}
                                         and has, at present, the largest and most active community of more than 1 million users." Drupal is an open source platform. That means it’s freely licensed in return for the sharing of new developments and improvements. Drupal’s rich, global community of developers and dedicated enthusiasts make continual contributions to its development, ensuring it stays reliable and innovative. This openness has only added to its appeal and popularity.
                                    </p>
                                    <h5>
                                        <b>The ranges of services you can grab from us include:</b>
                                    </h5>
                                    <ul className="text_color">
                                        <li>Drupal Application Development</li>
                                        <li>Drupal Web Development</li>
                                        <li>Drupal Deployment</li>
                                        <li>Drupal CMS Customization</li>
                                        <li>Drupal Module Development</li>
                                        <li>Drupal Template Design and Development</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 services-details-image">
                                <img loading="lazy"
                                    src="assets/img/service-detail-image/drupal.webp"
                                    className="wow fadeInUp"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </>

        </>
    )
}

export default CmsMainContent